import { GroupsByCategories } from 'components/context/types';
import * as React from 'react';
import { useState } from 'react';
import t from 'utils/translations';
import { SettingsMenu } from 'components/pages/categorypage/CategoryPage';
import { Popover } from 'antd';
import DeleteGroupModal from 'components/pages/grouplistpage/actionmenu/DeleteGroupModal';
import RenameGroupOrCategoryModal from 'components/pages/grouplistpage/actionmenu/RenameGroupOrCategoryModal';
import DeleteAllCompaniesFromGroup from 'components/pages/grouplistpage/actionmenu/DeleteAllCompaniesFromGroup';
import CompanyToGroupModal from 'components/common/modal/CompanyToGroupModal';

export interface GroupActionMenuProps {
    afterActionsFunction: () => void;
    groupsByCategories: GroupsByCategories[];
    id: string;
    name: string;
    numberOfCompaniesInGroup?: number;
    activatingElement: React.ReactNode;
    navigateAfterDeletion?: () => void;
}

export default function GroupActionMenu({
    afterActionsFunction,
    groupsByCategories,
    id,
    name,
    numberOfCompaniesInGroup,
    activatingElement,
    navigateAfterDeletion
}: GroupActionMenuProps) {
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [isRenameModalVisible, setIsRenameModalVisible] = useState(false);
    const [
        isDeleteCompaniesModalVisible,
        setIsDeleteCompaniesModalVisible
    ] = useState(false);
    const [
        isAddCompaniesModalVisible,
        setIsAddCompaniesModalVisible
    ] = useState(false);

    function PopOverContent() {
        return (
            <SettingsMenu>
                <li
                    key={'ADD_COMPANIES'}
                    onClick={() => setIsAddCompaniesModalVisible(true)}
                >
                    {t('ADD_COMPANIES')}
                </li>
                <li
                    key={'RENAME_GROUP'}
                    onClick={() => {
                        setIsRenameModalVisible(true);
                    }}
                >
                    {t('RENAME_GROUP')}
                </li>

                <li
                    key={'DELETE_COMPANIES_IN_GROUP'}
                    onClick={() => setIsDeleteCompaniesModalVisible(true)}
                >
                    {t('DELETE_COMPANIES_IN_GROUP')}
                </li>
                <li
                    key={'DELETE_GROUP'}
                    onClick={() => setIsDeleteModalVisible(true)}
                >
                    {t('DELETE_GROUP')}
                </li>
            </SettingsMenu>
        );
    }
    return (
        <>
            <Popover
                content={<PopOverContent />}
                placement={'bottomRight'}
                trigger="click"
                overlayStyle={{ zIndex: 999 }}
            >
                {activatingElement}
            </Popover>
            <DeleteGroupModal
                afterSuccess={() => {
                    setIsDeleteModalVisible(false);
                    afterActionsFunction();
                    if (navigateAfterDeletion) {
                        navigateAfterDeletion();
                    }
                }}
                closeModal={() => {
                    setIsDeleteModalVisible(false);
                }}
                name={name}
                groupId={id}
                visible={isDeleteModalVisible}
            />
            <RenameGroupOrCategoryModal
                afterSuccess={() => {
                    setIsRenameModalVisible(false);
                    afterActionsFunction();
                }}
                closeModal={() => {
                    setIsRenameModalVisible(false);
                }}
                id={id}
                initialName={name}
                isCategory={false}
                visible={isRenameModalVisible}
            />
            <DeleteAllCompaniesFromGroup
                afterSuccess={() => {
                    setIsDeleteCompaniesModalVisible(false);
                    afterActionsFunction();
                }}
                closeModal={() => setIsDeleteCompaniesModalVisible(false)}
                groupId={id}
                groupName={name}
                numberOfCompaniesInGroup={numberOfCompaniesInGroup || 0}
                visible={isDeleteCompaniesModalVisible}
            />
            <CompanyToGroupModal
                afterSuccess={() => {
                    setIsAddCompaniesModalVisible(false);
                    afterActionsFunction();
                }}
                closeModal={() => setIsAddCompaniesModalVisible(false)}
                preSelectedGroupId={id}
                groupsByCategories={groupsByCategories}
                visible={isAddCompaniesModalVisible}
            />
        </>
    );
}
